import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import $, { parseJSON } from 'jquery';
import services from "../../services/services";
import UsNumberValidate from '../../utility/usNumberValidate';
import moment from "moment";

const PersonalProfileViewAI = () => {

  const [jobTypes, setJobTypes] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [jobSeekerDetails, setJobSeekerDetails] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const jobSeekerId = queryParams.get('profileId');
  const pageid = queryParams.get('pppage');
  const [fileName, setFileName] = useState([]);
  const [fileExtension, setFileExtension] = useState([]);
  const [fileBase64, setFileBase64] = useState([]);

  const [pdfDownload, setPdfDownload] = useState([]);

  // --- NEW: State to hold the AI Result Data ---
  const [aiProfileData, setAiProfileData] = useState(null);
  const [matchingPoints, setMatchingPoints] = useState([]);
  const [isAiLoading, setIsAiLoading] = useState(false);

  var companyId = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
  const navigate = useNavigate();

  function strCatArr(arr) {
    if (Array.isArray(arr)) {
      return arr.join(", ");
    } else {
      return "";
    }
  }

  function getImage() {
    var files = document.getElementById('resume').files;
    if (files.length > 0) {
      var fname = files[0].name;
      var fextn = fname.split(".").pop();
      var fileActName = fname.split(".")[0];
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "doc" && fextn != "docx" && fextn != "pdf") {
        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
        return true;
      }
    }
  }

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var base64result = reader.result.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const getProfile = (jobSeekerId) => {
    services.getProfile(jobSeekerId).then((res) => {
      setJobSeekerDetails(res.data);

      // Legacy jQuery assignments
      $("#firstName").val(res.data.firstName);
      $("#lastName").val(res.data.lastName);
      $("#email").val(res.data.email);
      $("#phone").val(res.data.phone);
      $("#personalProfile").val(res.data.personalProfile);
      $("#education").val(res.data.educationExperiance);
      $("#lookingFor").val(res.data.lookingFor);
      $("#jobType").val(res.data.jobType);
      $("#resume").val(res.data.pdfByString);

      setPdfDownload(res.data.resumePath);

      var fext = res.data.fileExtension;
      if ((fext != ".doc" && fext != ".docx" && fext != ".pdf") || (fext == "")) {
        $("#resumeDiv").hide();
      }
      setJobType(res.data.jobType);

      setCategoriesSelected(res.data.categoriesOfExpertise);
      var companyCatIn = res.data.categoriesOfExpertise;

      $('#jobType').prop('selectedIndex', res.data.jobType);

      setTimeout(() => {
        if (companyCatIn) {
          for (var i = 0; i < companyCatIn.length; i++) {
            $('input[name="category"][value="' + companyCatIn[i] + '"]').trigger("click");
          }
        }
        validateCheck();

        var isCheck = true;
        var checkedValues = $("input[name='category']").val();
        if (!checkedValues) {
          isCheck = false;
          $("#categoryError").html("Category field is required");
        } else {
          isCheck = true;
          $("#categoryError").html("");
        }
        return isCheck;
      }, 500);
    });
  }

  const [categories, setCategory] = useState([]);

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  useEffect(() => {
    if (companyId == null || companyId == "null") {
      navigate('/Home');
    }

    $("#successMessage").hide();
    $('#phone').usPhoneFormat();
    getIndustryData();
    getProfile(jobSeekerId);
    $("#fileError").hide();

    services.getJobType().then((res) => {
      setJobTypes(res.data.content);
    });

    // --- NEW: Retrieve the AI Profile Data from localStorage ---
    if (jobSeekerId) {
      const storedAiData = localStorage.getItem(`ai_profile_${jobSeekerId}`);
      if (storedAiData) {
        try {
          setAiProfileData(JSON.parse(storedAiData));
          fetchMatchingPoints(JSON.parse(storedAiData));
        } catch (err) {
          console.error("Failed to parse AI profile data", err);
        }
      }
    }

  }, [jobSeekerId]);


  const fetchMatchingPoints = async (itemData) => {
    setIsAiLoading(true);
    try {
      const baseurl = process.env.React_App_AWS_API;
      //`${baseurl}analysis/matching-points`
      //http://3.144.188.63:8001/api/v1/analysis/matching-points
      const response = await fetch(`${baseurl}analysis/matching-points`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "query": itemData.search_text_query,
          "item_type": "resume", // As per your curl request
          "item_data": itemData,   // The complete object from local storage
          "full_text": itemData.search_text_query
        })
      });
      const resData = await response.json();
      if (resData.success) {
        setMatchingPoints(resData.matching_points);
      }
    } catch (error) {
      console.error("Error fetching matching points:", error);
    } finally {
      setIsAiLoading(false);
    }
  };

  const getIndustryData = () => {
    services.getIndustryData().then((res) => {
      setCategory(res.data.content);
    });
  }

  function validateCategory() {
    var isCheck = true;
    var checkedValues = $("input[name='category']:checked");
    var lenghtCheck = checkedValues.length;
    if (lenghtCheck == 0) {
      isCheck = false;
      $("#categoryError").html("Category field is required");
    } else {
      isCheck = true;
      $("#categoryError").html("");
    }
    return isCheck;
  }

  const validateCheck = () => {
    const checked = $('input[name="category"]:checked').length;
    if (checked >= 3) {
      $('input[name="category"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="category"]').prop('disabled', false);
    }
  }

  return (
    <>
      <main className="empr-directory-main">
        <div className="main-bgpatten"></div>
        <section className="headtitle-wrap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item headtitle ">
                      <Link to={"/personalProfiles?pageid=" + pageid} >Personal Profiles</Link>
                    </li>
                    <li className="breadcrumb-item headtitle "><a href="#">{jobSeekerDetails.firstName} {jobSeekerDetails.lastName}</a></li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <section className="company-detail-wrap py-5 ">
          <div className="container">
            <div className="row pb-3">
              <div className="d-flex">
                <span className="mr-1 rotate-90">
                  <img src="images/mob-arrow.png" alt="" />
                </span>
                {(() => {
                  return (<><Link to={`/personalProfiles?return=true&pageid=` + pageid} style={{ color: "#fff" }}>Back to Profiles List </Link></>);
                })()}
              </div>
            </div>
            <div className="row">
              <div className="col-12 ">
                <div className="white-bg p-4">
                  <div className="grid-item p-3 border-0">

                    {/* Classic Profile Header */}
                    <div className="grid-head align-items-center">
                      <div className="grid-img">
                        <img src={jobSeekerDetails.profilePicS3URL ? jobSeekerDetails.profilePicS3URL : "images/user-default.jpg"} className="w-100" alt="" />
                      </div>
                      <div className="grid-title-wrap">
                        <h4 className="margin-bottom-0">{jobSeekerDetails.firstName} {jobSeekerDetails.lastName}</h4>
                        <small className="d-flex">
                          <span className="mr-1"><b>Seeking: </b></span>
                          <span>{jobSeekerDetails.jobTypeName == 'Internship/Coop' ? 'College Intern' : jobSeekerDetails.jobTypeName}</span>
                        </small>
                      </div>
                    </div>

                    <div className="grid-body mb-4">
                      <div className="grid-body-item">
                        <div className="grid-body-inn">
                          <span>Updated:</span>
                          <span>{moment(jobSeekerDetails.updatedDate).utcOffset('-0400').format("MM/DD/YYYY")}</span>
                        </div>
                        <div className="grid-body-inn">
                          <span>Email:</span>
                          <span>{jobSeekerDetails.email}</span>
                        </div>
                        <div className="grid-body-inn">
                          <span>Phone:</span>
                          <span>{jobSeekerDetails.phone}</span>
                        </div>
                        <div className="grid-body-inn">
                          <span>Category:</span>
                          <span>{strCatArr(jobSeekerDetails.categoriesOfExpertiseName)}</span>
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    {/* --- NEW: DYNAMIC AI INSIGHTS CARD --- */}
                    {/* --- NEW: DYNAMIC AI INSIGHTS CARD --- */}
                    {aiProfileData && (
                      <div className="ai-card mb-5" style={{ maxWidth: "100%" }}>
                        <div className="ai-header">
                          <div className="ai-title">
                            <span className="ai-icon">
                              <img src="/images/icon-golf.PNG" alt="icon" />
                            </span>
                            <h2>AI Matching Score:</h2>
                          </div>
                          <div className="ai-badge">
                            {aiProfileData.score_percent ? Math.round(aiProfileData.score_percent) : 0}% Match
                          </div>
                        </div>

                        <h3 className="summary-title">
                          Profile Matching Summary and Observations:
                        </h3>

                        <ul className="ai-list">
                          {isAiLoading ? (
                            <li><i className="fa fa-spinner fa-spin"></i> Analyzing profile match points...</li>
                          ) : matchingPoints && matchingPoints.length > 0 ? (
                            matchingPoints.map((point, index) => (
                              <li key={index}>{point}</li>
                            ))
                          ) : aiProfileData.debug && aiProfileData.debug.explanation ? (
                            aiProfileData.debug.explanation
                              .split('. ')
                              .filter((sentence) => sentence.trim().length > 0)
                              .map((sentence, index) => (
                                <li key={index}>
                                  {sentence.trim()}{sentence.endsWith('.') ? '' : '.'}
                                </li>
                              ))
                          ) : (
                            <li>Highly relevant candidate match based on your search criteria for "{aiProfileData.search_text_query}".</li>
                          )}
                        </ul>

                        {/* Designer's Basic Information Block */}
                        <div className="st-emotion-cache-6c7yup e13xr0422 mt-4 pt-3 border-top">
                          <div data-testid="stMarkdownContainer" className="st-emotion-cache-1frkdi4 e1t8ru6f0">
                            <div data-testid="stHeadingWithActionElements" className="st-emotion-cache-1oqmf0p e1t8ru6f2">
                              <h5 id="basic-information" aria-labelledby=":r8:">
                                <span id=":r8:"> Basic Information</span>
                              </h5>
                            </div>
                          </div>

                          <div className="row px-2 mt-3">
                            {aiProfileData.yearsOfExperience !== undefined && aiProfileData.yearsOfExperience !== null && (
                              <div className="col-md-6 mb-2">
                                <strong style={{ color: '#555', fontSize: '14px' }}>Experience:</strong> <span style={{ textTransform: 'capitalize', fontSize: '14px' }}>{aiProfileData.yearsOfExperience} Years</span>
                              </div>
                            )}
                            {aiProfileData.location && (
                              <div className="col-md-6 mb-2">
                                <strong style={{ color: '#555', fontSize: '14px' }}>Location Match:</strong> <span style={{ textTransform: 'capitalize', fontSize: '14px' }}>{aiProfileData.location}</span>
                              </div>
                            )}
                            {aiProfileData.employmentType && (
                              <div className="col-md-6 mb-2">
                                <strong style={{ color: '#555', fontSize: '14px' }}>Employment:</strong> <span style={{ textTransform: 'capitalize', fontSize: '14px' }}>{aiProfileData.employmentType}</span>
                              </div>
                            )}
                            {aiProfileData.industries && aiProfileData.industries.length > 0 && (
                              <div className="col-md-6 mb-2">
                                <strong style={{ color: '#555', fontSize: '14px' }}>Industries:</strong> <span style={{ textTransform: 'capitalize', fontSize: '14px' }}>{aiProfileData.industries.join(', ')}</span>
                              </div>
                            )}
                            {aiProfileData.certifications && aiProfileData.certifications.length > 0 && (
                              <div className="col-md-12 mb-2 mt-2">
                                <strong style={{ color: '#555', fontSize: '14px' }}>Certifications:</strong> <span style={{ textTransform: 'capitalize', fontSize: '14px' }}>{aiProfileData.certifications.join(', ')}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Key Skills */}
                        {aiProfileData.skills && aiProfileData.skills.length > 0 && (
                          <div className="mt-4 pt-3 border-top">
                            <h5 className="mb-3">
                              <span> Key Skills Matched</span>
                            </h5>
                            <div className="skills mx-0 px-0 mt-2">
                              {aiProfileData.skills.map((skill, index) => (
                                <span key={index} className="skill" style={{ textTransform: "capitalize", display: "inline-block", marginRight: "8px", marginBottom: "8px" }}>{skill}</span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {/* --- END AI CARD --- */}

                    {/* Classic Text Blocks */}
                    <div className="view-item ppv mb-4">
                      <h5>Personal Profile:</h5>
                      <p dangerouslySetInnerHTML={{ __html: jobSeekerDetails.personalProfile }} />
                    </div>

                    <div className="view-item ppv mb-4">
                      <h5>Education:</h5>
                      <p dangerouslySetInnerHTML={{ __html: jobSeekerDetails.educationExperiance }} />
                    </div>

                    <div className="view-item ppv mb-4">
                      <h5>Certifications and Training:</h5>
                      <p dangerouslySetInnerHTML={{ __html: jobSeekerDetails.certificationTraining }} />
                    </div>

                    <div className="view-item ppv mb-4">
                      <h5>I Am Looking For:</h5>
                      <p dangerouslySetInnerHTML={{ __html: jobSeekerDetails.lookingFor }} />
                    </div>

                    <div className="view-item ppv mb-4" id="resumeDiv">
                      <h5>Resume:</h5>
                      <p><a target="_blank" rel="noreferrer" href={jobSeekerDetails.resumePath} download="resume"><button type="button" className="reg-button">Download</button></a></p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>
    </>
  )
};

PersonalProfileViewAI.propTypes = {};

PersonalProfileViewAI.defaultProps = {};

export default PersonalProfileViewAI;